<template>
  <div>
    <el-card v-auth="'/onlineSchoolTemplateManage/pageList'">
      <el-form
        ref="searchForm"
        :model="searchForm"
        :label-width="formLabelWidth"
      >
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="组件名称" prop="name">
              <el-input
                v-model="searchForm.name"
                placeholder="请输入组件名称"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="模板类型" prop="objectId">
              <el-select
                v-model="searchForm.objectId"
                placeholder="请选择模板类型"
                clearable
              >
                <el-option
                  v-for="item in goodsOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-button
              type="primary"
              @click="
                page.pageNumber = 1
                pageList()
              "
              icon="el-icon-search"
              >搜索</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px">
      <el-row :span="24" v-auth="'/onlineSchoolTemplateManage/addTemplate'">
        <el-col :span="12">
          <el-dropdown @command="handleCommand">
            <el-button type="primary">
              新增模板<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="item in goodsOptions"
                :key="item.id"
                :command="item.name"
                >{{ item.name }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>

          <!-- <el-button type="danger" @click="batchDeleteTemplate" icon="el-icon-minus">批量删除</el-button> -->
        </el-col>
      </el-row>
      <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        border
        @selection-change="selectionChange"
      >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column prop="name" label="组件名称"></el-table-column>
        <el-table-column prop="objectType" label="组件类型"></el-table-column>
        <el-table-column prop="" label="操作" width="180" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <span
                @click="updateTemplate(scope.row.id, scope.row.objectType)"
                v-auth="'/onlineSchoolTemplateManage/updateTemplate'"
                >编辑</span
              >
              <span
                @click="deleteTemplate(scope.row)"
                v-auth="'/onlineSchoolTemplateManage/deleteTemplate'"
                >删除</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        style="margin-top: 20px; text-align: right"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      >
      </el-pagination>
    </el-card>

    <el-dialog title="导入" :visible.sync="importFormVisible" width="80%" left>
      <el-upload
        class="upload-demo"
        :action="fileAction"
        :on-success="handleSuccess"
        :headers="reqData"
        :file-list="fileList"
      >
        <el-button size="small" type="primary" icon="el-icon-upload"
          >点击上传</el-button
        >
        <div slot="tip" class="el-upload__tip">
          只能上传xls、xlsx文件，且不超过1024kb
        </div>
      </el-upload>
      <el-table
        ref="multipleTable"
        :data="importForm.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        height="520"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="组件名称"></el-table-column>
        <el-table-column prop="height" label="高度"></el-table-column>
        <el-table-column prop="width" label="宽度"></el-table-column>
        <el-table-column prop="position" label="定位"></el-table-column>
        <el-table-column prop="col" label="列数"></el-table-column>
        <el-table-column prop="row" label="行数"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button type="primary" @click="importData" icon="el-icon-document"
          >导入数据</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      goodsOptions: [],
      importFormVisible: false,
      fileAction: `${process.env.BASE_URL}/template/upload`,
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      searchForm: {
        name: "",
        objectId: "",
      },
      editForm: {
        name: "",
        height: "",
        width: "",
        position: "",
        col: "",
        row: "",
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      fileList: [],
      loading: false,
      filter: "",
      treeData: [],
      defaultProps: {
        children: "list",
        label: "name",
      },
    };
  },
  computed: {
    reqData () {
      return this.$store.state.user;
    },
  },
  methods: {
    getGoodsOptions (val) {
      let parentId = "1415194153601642498";
      this.api.dictionary
        .getDictionaryListByParentId({
          parentId,
        })
        .then((res) => {
          this.goodsOptions = res.data;
        });
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange (val) {
      this.multipleSelection = val;
      val.map((e) => this.ids.push({ id: e.id }));
    },

    // 获取模板列表
    pageList () {
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.template
        .pageList(this.searchForm)
        .then((result) => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // 新增模板
    handleCommand (val) {
      this.goPage(undefined, val);
    },
    goPage (id, type) {
      const { href } = this.$router.resolve({
        path: "/onlineSchoolTemplate",
        query: { id, type },
      });
      window.open(href, "_blank");
    },
    // 编辑模板
    updateTemplate (id, val) {
      this.goPage(id, val);
    },

    // 删除模板
    deleteTemplate (row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.template
            .deleteTemplate([
              {
                id: row.id,
              },
            ])
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => { });
    },

    // 批量删除
    batchDeleteTemplate () {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.template
            .deleteTemplate(this.ids)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    reset () {
      this.$refs.searchForm.resetFields();
    },
    handleSuccess (response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel () {
      this.loading = true;
      this.api.template
        .exportExcel(this.searchForm)
        .then((result) => {
          location.href = result.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    importData () {
      this.api.template
        .importData(this.importForm.rows)
        .then((result) => {
          this.$message({
            type: "success",
            message: result.message,
          });
          this.pageList();
          this.importFormVisible = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleNodeClick (data) {
      this.searchForm.parentId = data.id;
      this.addForm.parentId = data.id;
      this.editForm.parentId = data.id;
      if (!data.disabled) {
        this.pageList();
      }
    },
  },
  mounted () {
    this.pageList();
    this.getGoodsOptions();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/onlineTemplate/onlineSchoolTemplateManage.vue